import {
    Modal as ChakraModal,
    ModalProps as ChakraModalProps,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
} from '@chakra-ui/react'

type ModalProps = ChakraModalProps & { hideCloseBtn: boolean; isCentered?: boolean }

export function Modal(props: ModalProps) {
    const { hideCloseBtn, isCentered = true, ...otherProps } = props

    return (
        <ChakraModal isCentered={isCentered} {...otherProps}>
            <ModalOverlay />
            <ModalContent>
                {!hideCloseBtn && <ModalCloseButton />}
                {props.children}
            </ModalContent>
        </ChakraModal>
    )
}
